import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageDialogConfig } from '../../models/message-dialog-config';

@Component({
  selector: 'app-message-dialog-continue-cancel-buttons',
  templateUrl: './message-dialog-continue-cancel-buttons.component.html',
  styleUrls: ['./message-dialog-continue-cancel-buttons.component.scss']
})
export class MessageDialogContinueCancelButtonsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<MessageDialogContinueCancelButtonsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogConfig,
    ) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  confirm(): void {
    this.dialogRef.close(true);
  }
  getTitle(){
    return this.data.title; 
  }
  getContent(){
    return this.data.content; 
  }
  getOkButtonLabel(){
    return this.data.okButtonLabel?? 'Continue'; 
  }
  getCancelButtonLabel(){
    return this.data.cancelButtonLabel?? 'Cancel'; 
  }

}
